import { IconSource } from "@livechat/design-system-react-components";

import { IconsEnum } from "components/icon/Icon";
import { ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import Role from "constants/role";

export enum NavigationItems {
  Tickets = "tickets",
  Agents = "agents",
  Reports = "reports",
  Subscription = "subscription",
  Marketplace = "marketplace",
  Settings = "settings",
  Logout = "logout",
  Help = "help",
  MyProfile = "my-profile",
  News = "news",
  Automations = "automations",
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface NavigationItemInterface {
  id: NavigationItems | string;
  name: string;
  icon?: IconsEnum | string;
  iconName?: IconSource;
  iconNameFilled?: IconSource;
  customIconUrl?: string;
  activeWhenAppAccessNotAllowed?: boolean;
  path?: string;
  placement?: "top" | "bottom" | "mobile";
  breakpoints?: ResponsiveBreakpointType[];
  permissions?: Role[];
  isIntegration?: boolean;
}
